import * as React from "react";
import { type PromptGeneratorContextState } from "./types";

export interface PromptGeneratorContextType {
  state: PromptGeneratorContextState;
  setState: React.Dispatch<React.SetStateAction<PromptGeneratorContextState>>;
}

export const PromptGeneratorContext = React.createContext<PromptGeneratorContextType | undefined>(undefined);
